import API from "./api";

export async function fetchToolCatalog(showAll = false) {
  const response = await API.get("/api/admin/tools", {
    params: { show_all: showAll ? "true" : "false" }
  });
  return response.data;
}

export async function createScanJob(payload) {
  const response = await API.post("/api/admin/scan-jobs", payload);
  return response.data;
}

export async function fetchScanJob(jobId) {
  const response = await API.get(`/api/admin/scan-jobs/${jobId}`);
  return response.data;
}

export async function fetchScanProfiles() {
  const response = await API.get("/api/scan/profiles");
  return response.data;
}

export async function resumeScanJob(jobId) {
  const response = await API.post(`/api/admin/scan-jobs/${jobId}/resume`);
  return response.data;
}
